export default __webpack_public_path__ + "static/media/gif.a65c33e2.svg";